import { useState, useEffect } from "react"

/**
 * Hook to check if window width exceeds a given width.
 *
 * @param width Breakpoint width to check against.
 * @returns Boolean indicating if window width is above the given width.
 */

const useBreakpoint = (width: number) => {
    const [isAboveWidth, setIsAboveWidth] = useState(false)

    useEffect(() => {
        const checkWidth = () => setIsAboveWidth(window.innerWidth > width)
        checkWidth()
        window.addEventListener("resize", checkWidth)
        return () => window.removeEventListener("resize", checkWidth)
    }, [width])

    return isAboveWidth
}

export default useBreakpoint
